/* globals data, isUnfiltered, leagueAverageDataFilteredGrouped, serverParams */
import Table from 'bam-node-savant-table/table'
import { displayFn, guff } from 'bam-node-baseball-savant/utils/guff'

import initStaticHeaders from '../utils/static-headers'
import { populateUrl } from '../utils/leaderboard-filter-helpers'
import { getFilteredData } from '../utils/bat-tracking-table-helpers'
import updatePlayerSearch from '../bat-tracking-viz'
import concatGroupedHeaders from '../utils/concat-grouped-headers'
import getBatTrackingFirstHeaders from '../utils/bat-tracking-first-headers'
import getGroupedHeaders from '../utils/get-grouped-headers'

const urlSearchParams = new URLSearchParams(window.location.search)
const type = urlSearchParams.get('type') || 'batter'
const seasonEnd = urlSearchParams.get('seasonEnd') || '2024'
const isBatter = type === 'batter'

const tableDivId = 'bat_tracking_table'

const firstHeaders = getBatTrackingFirstHeaders(
    serverParams.type,
    serverParams.secondaryGroupBy
)

const isLeague = serverParams.type === 'league'

const headers = [
    // Player, Team, Side, etc
    ...firstHeaders,

    // {
    //     name: 'Avg. Bat Speed',
    //     field: 'avg_sweetspot_speed_mph',
    //     headerClass: `th-component-header align-center th-vertical-bottom`,
    //     fieldClass: `tr-data align-center`,
    //     defaultSortDir: 'desc',
    //     type: 'number',
    //     displayFn: (val) => guff(val, 'swing_speed'),
    // },
    {
        name: 'Avg. <br/>Bat Speed',
        field: 'avg_sweetspot_speed_mph_qualified',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => guff(val, 'swing_speed_qualified'),
        toolTip: 'Competitive Swings Only',
        highlight: [62, 71, 80],
    },
    {
        name: 'Fast Swing<br/>Rate<a class="th-glossary-link" href="https://www.mlb.com/glossary/statcast/fast-swing-rate" target="_blank">[?]</a>',
        field: 'avg_is_sweetspot_speed_high_qualified',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn,
        toolTip: 'Competitive Swings Only',
    },
    // {
    //     name: 'Squared-Up ',
    //     field: 'squared_up',
    //     headerClass: `th-component-header align-center th-vertical-bottom`,
    //     fieldClass: `tr-data align-center`,
    //     defaultSortDir: 'desc',
    //     type: 'number',
    // },
    // {
    //     name: 'Squared-Up (Q)',
    //     field: 'squared_up_qualified',
    //     headerClass: `th-component-header align-center th-vertical-bottom`,
    //     fieldClass: `tr-data align-center`,
    //     defaultSortDir: 'desc',
    //     type: 'number',
    // },
    {
        name: '#',
        field: 'squared_up_qualified',
        headerClass: `th-component-header align-center th-vertical-bottom border-left`,
        fieldClass: `tr-data align-center border-left`,
        defaultSortDir: 'desc',
        type: 'number',
        toolTip: 'Competitive Swings Only',
        displayFn: (val) => val?.toLocaleString() || val,
    },
    {
        name: '% Contact',
        field: 'squared_up_per_bat_contact',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn,
        toolTip: 'Competitive Swings Only',
    },
    {
        name: '% Swing',
        field: 'squared_up_per_swing',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn,
        toolTip: 'Competitive Swings Only',
    },
    {
        name: '#',
        field: 'squared_up_with_speed_qualified',
        headerClass: `th-component-header align-center th-vertical-bottom border-left`,
        fieldClass: `tr-data align-center border-left`,
        defaultSortDir: 'desc',
        type: 'number',
        toolTip: 'Competitive Swings Only',
        displayFn: (val) => val?.toLocaleString() || val,
    },
    {
        name: '% Contact',
        field: 'squared_up_with_speed_per_bat_contact',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn,
        toolTip: 'Competitive Swings Only',
    },
    {
        name: '% Swing',
        field: 'squared_up_with_speed_per_swing',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn,
        toolTip: 'Competitive Swings Only',
    },
    {
        name: 'Swing <br/>Length<a class="th-glossary-link" href="https://www.mlb.com/glossary/statcast/swing-length" target="_blank">[?]</a>',
        field: 'swing_length_qualified',
        headerClass: `th-component-header align-center th-vertical-bottom border-left`,
        fieldClass: `tr-data align-center border-left`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn,
        toolTip: 'Competitive Swings Only',
    },
    {
        name: 'Swords<a class="th-glossary-link" href="https://www.mlb.com/glossary/statcast/sword" target="_blank">[?]</a>',
        field: 'swords',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data align-center border-right`,
        defaultSortDir: 'desc',
        type: 'number',
        toolTip: 'All Swings',
        displayFn: (val) => val?.toLocaleString() || val,
    },
    {
        name: 'Competitive <br/>Swings',
        field: 'swings_qualified',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => val?.toLocaleString() || val,
    },
    {
        name: '% of Swings, <br/> Competitive',
        field: 'percent_qualified',
        headerClass: `th-component-header align-center th-vertical-bottom ${
            isUnfiltered ? 'hide' : ''
        }`,
        fieldClass: `tr-data align-center ${isUnfiltered ? 'hide' : ''}`,
        defaultSortDir: 'desc',
        type: 'number',
        displayFn: (val) => (val * 100).toFixed(1),
    },
    {
        name: 'Hit Into<br/>Play',
        field: 'hit_into_play_qualified',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data align-center`,
        defaultSortDir: 'desc',
        type: 'number',
        toolTip:
            '# of competitive swings which resulted in contact (includes foul balls)',
        displayFn: (val) => val?.toLocaleString() || val,
    },
    // {
    //     name: 'Hard-swings',
    //     field: 'sweetspot_speed_high_qualified',
    //     headerClass: `th-component-header align-center th-vertical-bottom`,
    //     fieldClass: `tr-data align-center`,
    //     defaultSortDir: 'desc',
    //     type: 'number',
    //     toolTip: 'Competitive Swings Only',
    // },
]

if (isUnfiltered && isBatter) {
    headers.push({
        name: 'View <br /> Visual',
        field: 'player_id',
        headerClass: `th-component-header align-center th-vertical-bottom border-left`,
        fieldClass: `tr-data align-center border-left`,
        sortable: false,
        displayFn: (_, row) => {
            const side = row.n_sides > 1 ? '' : row.side
            const year = Number(seasonEnd)
            const url = `/visuals/bat-speed-distribution?playerIds=${row.id}&years=${year}&type=batter&sides=${side}`
            return `<a href="${url}" target="_blank">Link</a>`
        },
    })
}

const groupHeaders = getGroupedHeaders(serverParams.secondaryGroupBy)

function getFirstColspan() {
    // League hides team and side by default
    let colspan = isLeague ? 2 : 4

    // Add the extra group by columns
    colspan += groupHeaders.length

    return colspan
}

function getLastColspan() {
    let colspan = 2

    // % of swings competitive
    if (!isUnfiltered) {
        colspan += 1
    }

    return colspan
}
const secondaryHeaders = [
    {
        name: '',
        colspan: getFirstColspan(),
        headerClass: 'th-name-header',
    },
    {
        name: 'mph',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: '>= 75mph',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: 'Squared-Up<a class="th-glossary-link" href="https://www.mlb.com/glossary/statcast/squared-up" target="_blank">[?]</a>',
        colspan: 3,
        headerClass: 'th-title-header',
    },
    {
        name: 'Blasts<a class="th-glossary-link" href="https://www.mlb.com/glossary/statcast/bat-tracking-blasts" target="_blank">[?]</a>',
        colspan: 3,
        headerClass: 'th-title-header',
    },
    {
        name: 'feet',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: '',
        colspan: getLastColspan(),
        headerClass: 'th-name-header',
    },
]

let showLeagueAverage = false

function loadTable(filteredData) {
    if (showLeagueAverage) {
        // eslint-disable-next-line no-param-reassign
        filteredData = [
            ...filteredData,
            ...leagueAverageDataFilteredGrouped.map((d) => ({
                ...d,
                pinned: true,
            })),
            // {
            //     ...leagueAverageDataFiltered,
            //     pinned: true,
            // },
            // {
            //     ...leagueAverageData,
            //     pinned: true,
            // },
        ]
    }
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }
    const defaultSort = document.getElementById('sort').value
    const defaultSortDirection = document.getElementById('sortDir').value

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        headers: concatGroupedHeaders(
            headers,
            groupHeaders,
            'bat_side_formatted'
        ),
        secondaryHeaders,
        highlightFalsy: true,
        data: filteredData,
        hasPinned: true,
        defaultSort,
        defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = new URL(window.location)
            url.searchParams.set('sortColumn', column)
            url.searchParams.set('sortDirection', state)
            window.history.replaceState('', '', url.toString())
        },
    })

    initStaticHeaders(tableDivId, data)
}

const $input = document.querySelector('.table-search')
let currentData = data

if (data && data.length) {
    loadTable(data)

    if ($input) {
        $input.addEventListener('input', (e) => {
            currentData = getFilteredData(data, e.target.value)
            loadTable(currentData)
            updatePlayerSearch(e.target.value)
        })
    }
}
const $leagueAverageToggle = document.getElementById(
    'btn-toggle-league-average'
)

$leagueAverageToggle?.addEventListener('click', () => {
    showLeagueAverage = !showLeagueAverage
    loadTable(currentData)
})

document.getElementById('btn-update').addEventListener('click', () => {
    window.location = populateUrl()
})
